module.exports = __webpack_public_path__ + "img/dea75399bac85feff054218bae61780.1e9c0510.png";